<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('merchantShop.queryCondition') }}</span>
          </div>
          <div class="filter-container">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-input v-model="merchantShopInfo.conditions.shopId" :placeholder="$t('merchantShop.inputShopCode')"
                  clearable />
              </el-col>
              <el-col :span="6">
                <el-input v-model="merchantShopInfo.conditions.name" :placeholder="$t('merchantShop.inputShopName')"
                  clearable />
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="_queryShopMethod()">
                  <i class="el-icon-search"></i>
                  {{ $t('merchantShop.query') }}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row >
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('merchantShop.merchantShop') }}</span>
            <div style="float:right;">
              <el-button type="primary" size="small" @click="_openAddMerchantShopModal()">
                <i class="el-icon-plus"></i>
                {{ $t('merchantShop.addShop') }}
              </el-button>
              <el-button size="small" @click="_goBack">
                {{ $t('merchantShop.back') }}
              </el-button>
            </div>
          </div>
          <el-table :data="merchantShopInfo.shops" border style="width:100%">
            <el-table-column prop="shopLogo" :label="$t('merchantShop.shopLogo')" align="center" width="120">
              <template slot-scope="scope">
                <img v-if="scope.row.shopLogo" :src="scope.row.shopLogo"
                  style="width:60px;height:60px;border-radius:5px;" />
                <img v-else src="/img/noPhoto.jpg" style="width:60px;height:60px;border-radius:5px;" />
              </template>
            </el-table-column>
            <el-table-column prop="shopName" :label="$t('merchantShop.shopName')" align="center" />
            <el-table-column prop="shopTypeName" :label="$t('merchantShop.shopType')" align="center" />
            <el-table-column prop="storeName" :label="$t('merchantShop.merchantName')" align="center" />
            <el-table-column prop="returnAddress" :label="$t('merchantShop.merchantAddress')" align="center" />
            <el-table-column prop="returnLink" :label="$t('merchantShop.contactNumber')" align="center" />
            <el-table-column prop="stateName" :label="$t('merchantShop.shopStatus')" align="center" />
            <el-table-column prop="createTime" :label="$t('merchantShop.createTime')" align="center" />
            <el-table-column :label="$t('merchantShop.operation')" align="center" width="200">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openEditMerchantShopModel(scope.row)">
                  {{ $t('merchantShop.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteMerchantShopModel(scope.row)">
                  {{ $t('merchantShop.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="merchantShopInfo.conditions.page"
            :page-size="merchantShopInfo.conditions.row" layout="total, prev, pager, next"
            :total="merchantShopInfo.total" style="margin-top:20px;text-align:right;" />
        </el-card>
      </el-col>
    </el-row>

    <add-merchant-shop-info ref="addMerchantShopInfo" @refresh="queryShop" />
    <edit-merchant-shop-info ref="editMerchantShopInfo" @refresh="queryShop" />
    <delete-merchant-shop ref="deleteMerchantShop" @refresh="queryShop" />
  </div>
</template>

<script>
import { getShopList } from '@/api/admin/merchantShopApi'
import AddMerchantShopInfo from '@/components/admin/addMerchantShopInfo/addMerchantShopInfo'
import EditMerchantShopInfo from '@/components/admin/editMerchantShopInfo/editMerchantShopInfo'
import DeleteMerchantShop from '@/components/admin/deleteMerchantShop/deleteMerchantShop'

export default {
  name: 'MerchantShop',
  components: {
    AddMerchantShopInfo,
    EditMerchantShopInfo,
    DeleteMerchantShop
  },
  data() {
    return {
      merchantShopInfo: {
        shops: [],
        total: 0,
        records: 1,
        conditions: {
          name: '',
          merchantId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.merchantShopInfo.conditions.merchantId = this.$route.query.storeId
    this._listShops(this.merchantShopInfo.conditions.page, this.merchantShopInfo.conditions.row)
    console.log(this.merchantShopInfo.records)
  },
  methods: {
    handleCurrentChange(val) {
      this._listShops(val, this.merchantShopInfo.conditions.row)
    },
    queryShop() {
      this._listShops(1, this.merchantShopInfo.conditions.row)
    },
    async _listShops(page, row) {
      this.merchantShopInfo.conditions.page = page
      this.merchantShopInfo.conditions.row = row
      try {
        const res = await getShopList(this.merchantShopInfo.conditions)
        this.merchantShopInfo.total = res.total
        this.merchantShopInfo.records = res.records
        this.merchantShopInfo.shops = res.data
      } catch (error) {
        console.error('获取商铺列表失败:', error)
      }
    },
    _openAddMerchantShopModal() {
      this.$refs.addMerchantShopInfo.open({
        storeId: this.$route.query.storeId
      })
    },
    _openEditMerchantShopModel(row) {
      this.$refs.editMerchantShopInfo.open(row)
    },
    _openDeleteMerchantShopModel(row) {
      this.$refs.deleteMerchantShop.open(row)
    },
    _queryShopMethod() {
      this._listShops(1, this.merchantShopInfo.conditions.row)
    },
    _goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}

.box-card {
  margin-bottom: 20px;
}
</style>